import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './metaVendaTrimestreForm';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import { 
	setModoTela, initForm, salvar, excluir, 
	getLista, getListaUsuario
} from './metaVendaTrimestreActions';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import Select from '../common/form/select';
import consts from '../consts';

class MetaVendaTrimestre extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaUsuario();
	}
	
	componentWillUnmount() {
	
	}

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
	
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({});
								}} />
						</Grid>
					</Row>

				</ContentCardHeader>
				<ContentCardBody>

					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter>Ano</Th>
								<Th alignCenter>Trimestre</Th>
								<Th alignCenter>Nome</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{(this.props.lista).filter(item => {
								if (this.state.pesquisar
									&& !(`${DateFormat.formatarDataSqlParaTela(item.ano)}  ${item.trimestre || ''} ${item.nome_usuario || ''}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}
								return true;
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td alignCenter>{item.ano}</Td>
									<Td alignCenter>{item.trimestre}</Td>
									<Td alignCenter>{item.nome}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													volume_1: FormatUtils.formatarValorTela(item.volume_1 || 0, 2),
													volume_2: FormatUtils.formatarValorTela(item.volume_2 || 0, 2),
													volume_3: FormatUtils.formatarValorTela(item.volume_3 || 0, 2),
													volume_4: FormatUtils.formatarValorTela(item.volume_4 || 0, 2),
													volume_5: FormatUtils.formatarValorTela(item.volume_5 || 0, 2),
													margem_1: FormatUtils.formatarValorTela(item.margem_1 || 0, 2),
													margem_2: FormatUtils.formatarValorTela(item.margem_2 || 0, 2),
													margem_3: FormatUtils.formatarValorTela(item.margem_3 || 0, 2),
													margem_4: FormatUtils.formatarValorTela(item.margem_4 || 0, 2),
													margem_5: FormatUtils.formatarValorTela(item.margem_5 || 0, 2),
													prazo_1: FormatUtils.formatarValorTela(item.prazo_1 || 0, 2),
													prazo_2: FormatUtils.formatarValorTela(item.prazo_2 || 0, 2),
													prazo_3: FormatUtils.formatarValorTela(item.prazo_3 || 0, 2),
													prazo_4: FormatUtils.formatarValorTela(item.prazo_4 || 0, 2),
													prazo_5 : FormatUtils.formatarValorTela(item.prazo_5  || 0, 2),
													inadimplencia_1_maxima: FormatUtils.formatarValorTela(item.inadimplencia_1_maxima || 0, 2),
													inadimplencia_1_perda: FormatUtils.formatarValorTela(item.inadimplencia_1_perda || 0, 2),
													inadimplencia_2_maxima: FormatUtils.formatarValorTela(item.inadimplencia_2_maxima || 0, 2),
													inadimplencia_2_perda: FormatUtils.formatarValorTela(item.inadimplencia_2_perda || 0, 2),
													cliente_retomada_1: FormatUtils.formatarValorTela(item.cliente_retomada_1 || 0, 0),
													cliente_retomada_2: FormatUtils.formatarValorTela(item.cliente_retomada_2 || 0, 0),
													cliente_retomada_3: FormatUtils.formatarValorTela(item.cliente_retomada_3 || 0, 0),
													cliente_retomada_4: FormatUtils.formatarValorTela(item.cliente_retomada_4 || 0, 0),
													cliente_retomada_5: FormatUtils.formatarValorTela(item.cliente_retomada_5 || 0, 0),
													cliente_novo_1: FormatUtils.formatarValorTela(item.cliente_novo_1 || 0, 0),
													cliente_novo_2: FormatUtils.formatarValorTela(item.cliente_novo_2 || 0, 0),
													cliente_novo_3: FormatUtils.formatarValorTela(item.cliente_novo_3 || 0, 0),
													cliente_novo_4: FormatUtils.formatarValorTela(item.cliente_novo_4 || 0, 0),
													cliente_novo_5: FormatUtils.formatarValorTela(item.cliente_novo_5 || 0, 0),
													peso_volume_mes1: FormatUtils.formatarValorTela(item.peso_volume_mes1 || 0, 2),
													peso_volume_mes2: FormatUtils.formatarValorTela(item.peso_volume_mes2 || 0, 2),
													peso_volume_mes3: FormatUtils.formatarValorTela(item.peso_volume_mes3 || 0, 2)
												});
												this.props.initForm({
													...item,
													volume_1: FormatUtils.formatarValorTela(item.volume_1 || 0, 2),
													volume_2: FormatUtils.formatarValorTela(item.volume_2 || 0, 2),
													volume_3: FormatUtils.formatarValorTela(item.volume_3 || 0, 2),
													volume_4: FormatUtils.formatarValorTela(item.volume_4 || 0, 2),
													volume_5: FormatUtils.formatarValorTela(item.volume_5 || 0, 2),
													margem_1: FormatUtils.formatarValorTela(item.margem_1 || 0, 2),
													margem_2: FormatUtils.formatarValorTela(item.margem_2 || 0, 2),
													margem_3: FormatUtils.formatarValorTela(item.margem_3 || 0, 2),
													margem_4: FormatUtils.formatarValorTela(item.margem_4 || 0, 2),
													margem_5: FormatUtils.formatarValorTela(item.margem_5 || 0, 2),
													prazo_1: FormatUtils.formatarValorTela(item.prazo_1 || 0, 2),
													prazo_2: FormatUtils.formatarValorTela(item.prazo_2 || 0, 2),
													prazo_3: FormatUtils.formatarValorTela(item.prazo_3 || 0, 2),
													prazo_4: FormatUtils.formatarValorTela(item.prazo_4 || 0, 2),
													prazo_5 : FormatUtils.formatarValorTela(item.prazo_5  || 0, 2),
													inadimplencia_1_maxima: FormatUtils.formatarValorTela(item.inadimplencia_1_maxima || 0, 2),
													inadimplencia_1_perda: FormatUtils.formatarValorTela(item.inadimplencia_1_perda || 0, 2),
													inadimplencia_2_maxima: FormatUtils.formatarValorTela(item.inadimplencia_2_maxima || 0, 2),
													inadimplencia_2_perda: FormatUtils.formatarValorTela(item.inadimplencia_2_perda || 0, 2),
													cliente_retomada_1: FormatUtils.formatarValorTela(item.cliente_retomada_1 || 0, 0),
													cliente_retomada_2: FormatUtils.formatarValorTela(item.cliente_retomada_2 || 0, 0),
													cliente_retomada_3: FormatUtils.formatarValorTela(item.cliente_retomada_3 || 0, 0),
													cliente_retomada_4: FormatUtils.formatarValorTela(item.cliente_retomada_4 || 0, 0),
													cliente_retomada_5: FormatUtils.formatarValorTela(item.cliente_retomada_5 || 0, 0),
													cliente_novo_1: FormatUtils.formatarValorTela(item.cliente_novo_1 || 0, 0),
													cliente_novo_2: FormatUtils.formatarValorTela(item.cliente_novo_2 || 0, 0),
													cliente_novo_3: FormatUtils.formatarValorTela(item.cliente_novo_3 || 0, 0),
													cliente_novo_4: FormatUtils.formatarValorTela(item.cliente_novo_4 || 0, 0),
													cliente_novo_5: FormatUtils.formatarValorTela(item.cliente_novo_5 || 0, 0),
													peso_volume_mes1: FormatUtils.formatarValorTela(item.peso_volume_mes1 || 0, 2),
													peso_volume_mes2: FormatUtils.formatarValorTela(item.peso_volume_mes2 || 0, 2),
													peso_volume_mes3: FormatUtils.formatarValorTela(item.peso_volume_mes3 || 0, 2)
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													volume_1: FormatUtils.formatarValorTela(item.volume_1 || 0, 2),
													volume_2: FormatUtils.formatarValorTela(item.volume_2 || 0, 2),
													volume_3: FormatUtils.formatarValorTela(item.volume_3 || 0, 2),
													volume_4: FormatUtils.formatarValorTela(item.volume_4 || 0, 2),
													volume_5: FormatUtils.formatarValorTela(item.volume_5 || 0, 2),
													margem_1: FormatUtils.formatarValorTela(item.margem_1 || 0, 2),
													margem_2: FormatUtils.formatarValorTela(item.margem_2 || 0, 2),
													margem_3: FormatUtils.formatarValorTela(item.margem_3 || 0, 2),
													margem_4: FormatUtils.formatarValorTela(item.margem_4 || 0, 2),
													margem_5: FormatUtils.formatarValorTela(item.margem_5 || 0, 2),
													prazo_1: FormatUtils.formatarValorTela(item.prazo_1 || 0, 2),
													prazo_2: FormatUtils.formatarValorTela(item.prazo_2 || 0, 2),
													prazo_3: FormatUtils.formatarValorTela(item.prazo_3 || 0, 2),
													prazo_4: FormatUtils.formatarValorTela(item.prazo_4 || 0, 2),
													prazo_5 : FormatUtils.formatarValorTela(item.prazo_5  || 0, 2),
													inadimplencia_1_maxima: FormatUtils.formatarValorTela(item.inadimplencia_1_maxima || 0, 2),
													inadimplencia_1_perda: FormatUtils.formatarValorTela(item.inadimplencia_1_perda || 0, 2),
													inadimplencia_2_maxima: FormatUtils.formatarValorTela(item.inadimplencia_2_maxima || 0, 2),
													inadimplencia_2_perda: FormatUtils.formatarValorTela(item.inadimplencia_2_perda || 0, 2),
													cliente_retomada_1: FormatUtils.formatarValorTela(item.cliente_retomada_1 || 0, 0),
													cliente_retomada_2: FormatUtils.formatarValorTela(item.cliente_retomada_2 || 0, 0),
													cliente_retomada_3: FormatUtils.formatarValorTela(item.cliente_retomada_3 || 0, 0),
													cliente_retomada_4: FormatUtils.formatarValorTela(item.cliente_retomada_4 || 0, 0),
													cliente_retomada_5: FormatUtils.formatarValorTela(item.cliente_retomada_5 || 0, 0),
													cliente_novo_1: FormatUtils.formatarValorTela(item.cliente_novo_1 || 0, 0),
													cliente_novo_2: FormatUtils.formatarValorTela(item.cliente_novo_2 || 0, 0),
													cliente_novo_3: FormatUtils.formatarValorTela(item.cliente_novo_3 || 0, 0),
													cliente_novo_4: FormatUtils.formatarValorTela(item.cliente_novo_4 || 0, 0),
													cliente_novo_5: FormatUtils.formatarValorTela(item.cliente_novo_5 || 0, 0),
													peso_volume_mes1: FormatUtils.formatarValorTela(item.peso_volume_mes1 || 0, 2),
													peso_volume_mes2: FormatUtils.formatarValorTela(item.peso_volume_mes2 || 0, 2),
													peso_volume_mes3: FormatUtils.formatarValorTela(item.peso_volume_mes3 || 0, 2)
												});
												this.props.initForm({
													...item,
													volume_1: FormatUtils.formatarValorTela(item.volume_1 || 0, 2),
													volume_2: FormatUtils.formatarValorTela(item.volume_2 || 0, 2),
													volume_3: FormatUtils.formatarValorTela(item.volume_3 || 0, 2),
													volume_4: FormatUtils.formatarValorTela(item.volume_4 || 0, 2),
													volume_5: FormatUtils.formatarValorTela(item.volume_5 || 0, 2),
													margem_1: FormatUtils.formatarValorTela(item.margem_1 || 0, 2),
													margem_2: FormatUtils.formatarValorTela(item.margem_2 || 0, 2),
													margem_3: FormatUtils.formatarValorTela(item.margem_3 || 0, 2),
													margem_4: FormatUtils.formatarValorTela(item.margem_4 || 0, 2),
													margem_5: FormatUtils.formatarValorTela(item.margem_5 || 0, 2),
													prazo_1: FormatUtils.formatarValorTela(item.prazo_1 || 0, 2),
													prazo_2: FormatUtils.formatarValorTela(item.prazo_2 || 0, 2),
													prazo_3: FormatUtils.formatarValorTela(item.prazo_3 || 0, 2),
													prazo_4: FormatUtils.formatarValorTela(item.prazo_4 || 0, 2),
													prazo_5 : FormatUtils.formatarValorTela(item.prazo_5  || 0, 2),
													inadimplencia_1_maxima: FormatUtils.formatarValorTela(item.inadimplencia_1_maxima || 0, 2),
													inadimplencia_1_perda: FormatUtils.formatarValorTela(item.inadimplencia_1_perda || 0, 2),
													inadimplencia_2_maxima: FormatUtils.formatarValorTela(item.inadimplencia_2_maxima || 0, 2),
													inadimplencia_2_perda: FormatUtils.formatarValorTela(item.inadimplencia_2_perda || 0, 2),
													cliente_retomada_1: FormatUtils.formatarValorTela(item.cliente_retomada_1 || 0, 0),
													cliente_retomada_2: FormatUtils.formatarValorTela(item.cliente_retomada_2 || 0, 0),
													cliente_retomada_3: FormatUtils.formatarValorTela(item.cliente_retomada_3 || 0, 0),
													cliente_retomada_4: FormatUtils.formatarValorTela(item.cliente_retomada_4 || 0, 0),
													cliente_retomada_5: FormatUtils.formatarValorTela(item.cliente_retomada_5 || 0, 0),
													cliente_novo_1: FormatUtils.formatarValorTela(item.cliente_novo_1 || 0, 0),
													cliente_novo_2: FormatUtils.formatarValorTela(item.cliente_novo_2 || 0, 0),
													cliente_novo_3: FormatUtils.formatarValorTela(item.cliente_novo_3 || 0, 0),
													cliente_novo_4: FormatUtils.formatarValorTela(item.cliente_novo_4 || 0, 0),
													cliente_novo_5: FormatUtils.formatarValorTela(item.cliente_novo_5 || 0, 0),
													peso_volume_mes1: FormatUtils.formatarValorTela(item.peso_volume_mes1 || 0, 2),
													peso_volume_mes2: FormatUtils.formatarValorTela(item.peso_volume_mes2 || 0, 2),
													peso_volume_mes3: FormatUtils.formatarValorTela(item.peso_volume_mes3 || 0, 2)
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.metaVendaTrimestre,
	modoTela: state.metaVendaTrimestre.modoTela,
	lista: state.metaVendaTrimestre.lista,
	listaUsuario: state.metaVendaTrimestre.listaUsuario.filter(item => item.administrador)
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, 
	getLista, getListaUsuario
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(MetaVendaTrimestre);
